<template>
    <v-app style="background-color: #3AA2EB">
        <v-container style="margin-top: 35vh">
            <v-row align="center" justify="center">
                <v-img contain :src="src" max-width="50vh" max-height="50vw">
                </v-img>
            </v-row>
            <loader object="#009999" color1="#66CCCC" color2="#FFCC33" size="5" speed="2" bg="" objectbg="#999793"
                    opacity="100" name="circular"></loader>
        </v-container>
    </v-app>
</template>
<script>
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载
export default {
    data() {
        return {
            src: require("@/assets/dd.png")
        }
    },
    mounted(){
      this.enterMenu();
    },
    methods:{
        enterMenu(){
            let $this = this;
            /*setTimeout(()=> {
                this.$router.push("market")
            }, 3000)*/
            dd.ready(function() {
                // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
                dd.runtime.permission.requestAuthCode({
                    corpId: 'ding1d3b60040e5bb37a35c2f4657eb6378f',
                    onSuccess: function(result) {
                        $this.$api.dingtalk.login('etoak', result.code).then(data => {
                            if (data.flag) {
                                //这里将token 放入vuex中
                                $this.$store.commit('set_token', data.headers.authorization);
                                $this.$store.commit('setPermissionList', data.data.permissions);
                                let items = $this.$utils.menu.sortMenu(data.data.menus||[]);
                                $this.$store.commit('setMenuItems', items);
                                //这里跳转路由 登录成功的
                                $this.$router.push("market");

                                /*$this.$api.dingtalk.sign('student', {nonceStr:new Date().getTime(), timeStamp:new Date().getTime(), url:location.href}).then(data => {
                                    $this.ddInit(data.data);
                                });*/

                                /*$this.$api.sys.getUserInfo().then(userInfo => {
                                    $this.$store.commit('setUserInfo', userInfo.data);
                                });*/
                            } else {
                                if (data.code < 3000 || data.code > 3099) {
                                    if (data.msg) {
                                        $this.$dialog.alert(data.msg);
                                    }
                                }
                            }
                        });
                    },
                    onFail : function(err) {}

                });

                dd.error(function(error){
                    /**{errorMessage:"错误信息",// errorMessage 信息会展示出钉钉服务端生成签名使用的参数，请和您生成签名的参数作对比，找出错误的参数
		                errorCode: "错误码"} */
                    alert('dd error: ' + JSON.stringify(error));
                });
            });
        },
        ddInit(r){
            let $this = this;
            console.log('rr:',r)
            dd.config({
                agentId : r.agentId,
                corpId : r.corpId,
                timeStamp : r.timeStamp,
                nonceStr : r.nonceStr,
                signature : r.signature,
                jsApiList : [ 'runtime.info', 'biz.contact.choose',
                    'device.notification.confirm', 'device.notification.alert',
                    'device.notification.prompt', 'biz.ding.post',
                    'biz.util.openLink', 'biz.contact.complexPicker']
            });


            dd.ready(function() {
                dd.biz.contact.complexPicker({
                    title:"测试标题",            //标题
                    corpId:r.corpId,              //企业的corpId
                    multiple:!1,            //是否多选
                    limitTips:"超出了",          //超过限定人数返回提示
                    maxUsers:1,            //最大可选人数
                    pickedUsers:[],            //已选用户
                    pickedDepartments:[],          //已选部门
                    disabledUsers:["171321074020219"],            //不可选用户
                    disabledDepartments:["402488627"],        //不可选部门
                    requiredUsers:[],            //必选用户（不可取消选中状态）
                    requiredDepartments:[],        //必选部门（不可取消选中状态）
                    appId:r.agentId,              //微应用Id，企业内部应用查看AgentId
                    responseUserOnly:true,        //返回人，或者返回人和部门
                    startWithDepartmentId:0 ,   //仅支持0和-1
                    onSuccess: function(result) {
                        console.log(result)
                        $this.onSelectEmp(result);
                    },
                    onFail : function(err) {
                        //console.error('ddd error: ' + JSON.stringify(err))
                        alert('ddd error: ' + JSON.stringify(err));
                    }
                });


                dd.error(function(error){
                    alert('dd error: ' + JSON.stringify(error));
                });
            });
        },
        onSelectEmp(selectEmp){
            this.$api.dingtalk.bind('student', selectEmp.users[0].emplId).then(data => {
                alert(JSON.stringify(data));
            })
        }
    },
}
</script>
<style>
</style>
